import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { setAccessAllowed } from '../services/subscriptionService';
import './SubscriptionPage.css';

const SubscriptionCallbackPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState('processing');
  
  useEffect(() => {
    // Parse query parameters from URL
    const queryParams = new URLSearchParams(location.search);
    const result = queryParams.get('result');
    const token = queryParams.get('token');
    
    if (result === 'success' && token) {
      // Set access allowed to true
      setAccessAllowed(true);
      setStatus('success');
      
      // Redirect to home page after 3 seconds
      setTimeout(() => {
        navigate('/');
      }, 3000);
    } else {
      setStatus('failed');
    }
  }, [location, navigate]);
  
  const handleGoBack = () => {
    navigate('/');
  };
  
  return (
    <div className="subscription-page">
      <div className="subscription-header">
        <button onClick={handleGoBack} className="back-button">
          ← กลับไปที่เกม
        </button>
        <h1>🎮 สถานะการสมัคร</h1>
      </div>
      
      <div className="subscription-content">
        <div className="subscription-info">
          {status === 'processing' && (
            <div className="subscription-processing">
              <div className="processing-icon">⏳</div>
              <h2>กำลังดำเนินการสมัครสมาชิก</h2>
              <p>โปรดรอสักครู่ขณะที่เรากำลังดำเนินการสมัครสมาชิกของคุณ...</p>
            </div>
          )}
          
          {status === 'success' && (
            <div className="subscription-success">
              <div className="success-icon">✅</div>
              <h2>สมัครสมาชิกสำเร็จ!</h2>
              <p>
                ขอบคุณสำหรับการสมัครสมาชิก! คุณสามารถเข้าถึงเกมพรีเมียมทั้งหมดได้แล้ว<br/>
                คุณจะถูกนำไปยังหน้าหลักในอีกไม่กี่วินาที
              </p>
            </div>
          )}
          
          {status === 'failed' && (
            <div className="subscription-failed">
              <div className="failed-icon">❌</div>
              <h2>การสมัครสมาชิกล้มเหลว</h2>
              <p>
                เราไม่สามารถดำเนินการสมัครสมาชิกของคุณได้<br/>
                โปรดลองอีกครั้งหรือติดต่อฝ่ายสนับสนุน
              </p>
              <div className="action-buttons">
                <button onClick={() => navigate('/subscription')} className="retry-button">
                  ลองอีกครั้ง
                </button>
                <button onClick={handleGoBack} className="back-button">
                  กลับไปที่เกม
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCallbackPage;